import type { insuranceCoverageApiSpec } from "@wingspanhq/wingspan-api-types";
import { toWSDateString } from "@wingspanhq/fe-component-library";

export const selectorInsuranceCoverageStatusDescriptionByInsurance = (
  insurance: insuranceCoverageApiSpec.InsuranceCoverage,
  now: Date
): string => {
  const result: string[] = [];

  const isInactive = insurance.expirationDate && insurance.expirationDate < now;
  const oneMonthFromNow = new Date(now);
  oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
  const isExpiringSoon =
    insurance.expirationDate &&
    insurance.expirationDate > now &&
    insurance.expirationDate <= oneMonthFromNow;

  if (isInactive) {
    result.push(`Ended on ${toWSDateString(insurance.expirationDate)}`);
  } else {
    if (isExpiringSoon) {
      result.push(`Effective on ${toWSDateString(insurance.effectiveDate)}`);
      result.push(`Expires on ${toWSDateString(insurance.expirationDate)}`);
    } else if (insurance.effectiveDate > now) {
      result.push(`Effective on ${toWSDateString(insurance.effectiveDate)}`);
    } else if (insurance.effectiveDate < now) {
      result.push(`Since ${toWSDateString(insurance.effectiveDate)}`);
      if (insurance.expirationDate) {
        result.push(`Expires on ${toWSDateString(insurance.expirationDate)}`);
      }
    }
  }

  return result.join(",\n");
};
